import { render } from "./file-text.vue.js?vue&type=template&id=9795ac18!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./file-text.vue?vue&type=template&id=9795ac18"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__